import PublicHttpClient from '../../services/public-http-client';
import ApplicationAppService from '../application-app-service';
import { IPublicClientResponse } from '../../../model/public/client/response/public-client-response';

const findByDomain = async (domain: string): Promise<IPublicClientResponse> => {
    const { multitenant } = ApplicationAppService.getApplicationData();
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/Public/Client/FindByDomain/${multitenant}`,
        params: { domain }
    }).then((response) => response.data);
};

const PublicClientAppService = { findByDomain };
export default PublicClientAppService;
